import { render, staticRenderFns } from "./customerContact.vue?vue&type=template&id=6924daca&scoped=true&"
import script from "./customerContact.vue?vue&type=script&lang=js&"
export * from "./customerContact.vue?vue&type=script&lang=js&"
import style0 from "./customerContact.vue?vue&type=style&index=0&id=6924daca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6924daca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6924daca')) {
      api.createRecord('6924daca', component.options)
    } else {
      api.reload('6924daca', component.options)
    }
    module.hot.accept("./customerContact.vue?vue&type=template&id=6924daca&scoped=true&", function () {
      api.rerender('6924daca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/groupChat/components/customerContact.vue"
export default component.exports